import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox } from "components"
import { thousandSeparator } from "utils"
import classes from "./SccsmHeader.module.scss"

const SccsmHeader = props => {
  const {
    expectedCashAmount,
    printReport,
    setPrintReport,
    actualCashAmount
  } = props

  const [t, i18n] = useTranslation()

  const diffrence =
    Math.round(
      Number(actualCashAmount) - expectedCashAmount
    )

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["between"]}>
        <span>{t("موجودی_صندوق")}</span>
        <span>
          {thousandSeparator(expectedCashAmount)}
        </span>
      </div>

      <div className={clsx(classes["between"], classes["active"])}>
        <span>{t("موجودی_صندوق_واقعی")}</span>
        <span>
          {thousandSeparator(actualCashAmount)}
        </span>
      </div>

      <div className={classes["between"]}>
        <span>{t("تفاوت")}</span>
        <span>
          {thousandSeparator(diffrence)}
        </span>
      </div>

      <div className={classes["row"]}>
        <Checkbox
          className={clsx(
            classes["checkbox"],
            isLtr && classes["checkbox-ltr"]
          )}
          checked={printReport}
          onChange={(checked) => setPrintReport(checked)}
        />
        <span>{t("پرینت_گزارش_شیفت")}</span>
      </div>
    </Fragment>
  )
}

export default SccsmHeader